export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_q05_b.c55cfe55.png";